// Pure predicate for the "press E to enter edit mode" hotkey.
// Mirrors the same input/contenteditable + modifier gating used by
// the Cmd/Ctrl+K workspace-switcher hotkey at app.jsx:1199-1211.

export function shouldFireEditShortcut(e) {
  if (!e) return false;
  if (e.metaKey || e.ctrlKey || e.altKey) return false;
  if (e.key !== 'e' && e.key !== 'E') return false;
  const t = e.target;
  if (!t) return true;
  if (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT') return false;
  if (t.isContentEditable) return false;
  return true;
}
